import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Types } from '@grandvisionhq/graphql';
import { Toggletip } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';
import { useLatestDynamicDeliveryEstimation } from '@grandvisionhq/svc-dynamic-delivery-estimation';
import { useDeliveryIndicator } from '../../../contexts/DeliveryIndicator/context.js';
import { formatDeliveryDate } from '../../../utils/formatDeliveryDate.js';
import { DeliveryIndicator } from '../components/DeliveryIndicator.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';
import { DeliveryIndicatorModalContainer } from './DeliveryIndicatorModal.js';

var DynamicDeliveryIndicator = (_param)=>{
    var { deliveryItems , fallbackLabel , view ='full' , hasRxLens  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "deliveryItems",
        "fallbackLabel",
        "view",
        "hasRxLens"
    ]);
    const { getLabel , locale  } = useIntl();
    const { deliveryInfo  } = useDeliveryIndicator();
    const deliveryLabel = getLabel('products.deliveryEstimation.label');
    const transformDeliveryItems = React.useMemo(()=>{
        const itemInfo = deliveryItems && deliveryItems.length > 0 ? deliveryItems.map((item)=>swcHelpers.objectSpread({
                sku: item.sku,
                quantity: item.quantity
            }, hasRxLens ? {
                bundleLineItemType: Types.BundleLineItemType.PRESCRIPTION_GLASSES
            } : {})
        ) : [];
        return {
            itemInfo,
            shippingMethodKey: null
        };
    }, [
        deliveryItems,
        hasRxLens
    ]);
    const { data , loading , error  } = useLatestDynamicDeliveryEstimation({
        queryInputArgs: transformDeliveryItems
    });
    const deliveryMessage = React.useMemo(()=>{
        if ((data === null || data === void 0 ? void 0 : data.earliestDeliveryDate) && (data === null || data === void 0 ? void 0 : data.latestDeliveryDate)) {
            return `${deliveryLabel} ${formatDeliveryDate(locale, data === null || data === void 0 ? void 0 : data.earliestDeliveryDate)} - ${formatDeliveryDate(locale, data === null || data === void 0 ? void 0 : data.latestDeliveryDate)}`;
        }
        if (data === null || data === void 0 ? void 0 : data.earliestDeliveryDate) {
            return `${deliveryLabel} ${formatDeliveryDate(locale, data === null || data === void 0 ? void 0 : data.earliestDeliveryDate)}`;
        }
        return '';
    }, [
        data,
        deliveryLabel,
        locale
    ]);
    const tooltipSlot = deliveryInfo ? /*#__PURE__*/ React.createElement(DeliveryIndicatorModalContainer, null) : /*#__PURE__*/ React.createElement(Toggletip, {
        message: getLabel('products.deliveryIndicator.deliveryTooltip')
    });
    return /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({
        deliveryMessage: deliveryMessage,
        isLoading: loading,
        hasError: !!error,
        view: view,
        fallbackLabel: fallbackLabel,
        tooltipSlot: tooltipSlot
    }, rest));
};

export { DynamicDeliveryIndicator };
//# sourceMappingURL=DynamicDeliveryIndicator.js.map
